import React from 'react';
import { Link } from 'react-router-dom';
import { canadianCities } from '../../data/locations';
import { industries } from '../../data/industries';

export default function FooterSEOLinks() {
  // Group SK/AB cities
  const albertaCities = canadianCities.filter(city => city.provinceCode === 'AB');
  const saskCities = canadianCities.filter(city => city.provinceCode === 'SK');
  const primaryIndustries = industries.slice(0, 6);
  
  return (
    <div className="border-t border-gray-800 mt-12 pt-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Alberta Cities */}
        <div>
          <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
            Alberta Financial Advisors
          </h4>
          <ul className="space-y-2">
            {albertaCities.map(city => (
              <li key={city.id}>
                <Link 
                  to={`/financial-advisor-${city.slug}`}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  {city.name} Financial Advisor
                </Link>
              </li>
            ))}
            <li className="pt-2">
              <Link 
                to="/alberta-financial-advisor"
                className="text-sm text-amber-500 hover:text-amber-400 font-medium transition-colors"
              >
                All Alberta Locations →
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Saskatchewan Cities */}
        <div>
          <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
            Saskatchewan Financial Advisors
          </h4>
          <ul className="space-y-2">
            {saskCities.map(city => (
              <li key={city.id}>
                <Link 
                  to={`/financial-advisor-${city.slug}`}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  {city.name} Financial Advisor
                </Link>
              </li>
            ))}
            <li className="pt-2">
              <Link 
                to="/saskatchewan-financial-advisor"
                className="text-sm text-amber-500 hover:text-amber-400 font-medium transition-colors"
              >
                All Saskatchewan Locations →
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Industries Column */}
        <div>
          <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
            Industry Specialization
          </h4>
          <ul className="space-y-2">
            {primaryIndustries.map(industry => (
              <li key={industry.id}>
                <Link 
                  to={`/${industry.slug}-financial-advisor`}
                  className="text-sm text-gray-300 hover:text-white transition-colors"
                >
                  {industry.name}
                </Link>
              </li>
            ))}
            <li>
              <Link 
                to="/industries"
                className="text-sm text-amber-500 hover:text-amber-400 font-medium transition-colors"
              >
                All Industries →
              </Link>
            </li>
          </ul>
        </div>
        
        {/* Popular SK/AB Combinations */}
        <div>
          <h4 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
            Popular Searches
          </h4>
          <ul className="space-y-2">
            <li>
              <Link 
                to="/medical-professionals-calgary"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                Calgary Medical Professionals
              </Link>
            </li>
            <li>
              <Link 
                to="/small-business-owners-calgary"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                Calgary Business Owners
              </Link>
            </li>
            <li>
              <Link 
                to="/medical-professionals-edmonton"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                Edmonton Medical Professionals
              </Link>
            </li>
            <li>
              <Link 
                to="/medical-professionals-saskatoon"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                Saskatoon Medical Professionals
              </Link>
            </li>
            <li>
              <Link 
                to="/medical-professionals-regina"
                className="text-sm text-gray-300 hover:text-white transition-colors"
              >
                Regina Medical Professionals
              </Link>
            </li>
            <li>
              <Link 
                to="/prairie-financial-advisor"
                className="text-sm text-amber-500 hover:text-amber-400 font-medium transition-colors"
              >
                All Prairie Locations →
              </Link>
            </li>
          </ul>
        </div>
      </div>
      
      {/* SEO Text */}
      <div className="mt-12 pt-8 border-t border-gray-800">
        <p className="text-xs text-gray-400 text-center max-w-4xl mx-auto">
          PCM Financial provides comprehensive wealth management, investment planning, and insurance solutions 
          across Saskatchewan and Alberta. Serving professionals and families in Calgary, Edmonton, Saskatoon, 
          Regina, and all major Prairie cities with specialized expertise for medical professionals, business owners, 
          executives, and high-net-worth families.
        </p>
      </div>
    </div>
  );
}